// extracted by mini-css-extract-plugin
module.exports =  {"gig-attribute-wrapper":"VXDPSlT","gigAttributeWrapper":"VXDPSlT","gig-attribute":"_9PNlJb","gigAttribute":"_9PNlJb","attribute-text":"ZR50ZWL","attributeText":"ZR50ZWL"};